var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',_vm._b({model:{value:(_vm.defaultedValue),callback:function ($$v) {_vm.defaultedValue=$$v},expression:"defaultedValue"}},'v-switch',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }